import React from "react";
import { UserNav } from "./UserNav";
import { Link } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

const Navbar = () => {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <header className="bg-white border-b">
      <div className="flex items-center justify-between h-12 px-6 bg-gray-200 text-primary">
        <div className="flex items-center space-x-4">
          <img src="/logo.png" alt="logo" className="h-7 w-auto" />
          <nav className="hidden md:flex items-center space-x-4 lg:space-x-6 text-sm font-medium uppercase">
            <Link to="/home">Home</Link>
            <Link to="/support">Support</Link>
          </nav>
        </div>
        <div className="flex items-center space-x-4">
          <h2 className="text-sm md:text-base lg:text-lg font-semibold tracking-[0.4em]">
            TriVistaIQ
          </h2>
          <UserNav handleLogout={handleLogout} />
        </div>
      </div>
    </header>
  );
};

export default Navbar;
